import { BroadcastPopupService } from './../../../service/broadcast-popup.service';
import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ByocMissionService } from '../../service/mission.service';
import { ByocService } from '@app/byoc/popup/service/byoc.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@app/service/message.service';
import { Router } from '@angular/router';
import { ByocCourseService } from '@app/byoc/popup/course/service/course.service';
import { ByocMissionStepCourseListComponent } from './list/list.component';
import { BroadcastMessage } from '@app/core/service';

enum origin {
    all = 0,
    st = 1,
    custom = 2,
}

@Component({
    selector: 'app-byoc-mission-step-course',
    templateUrl: './course.component.html',
    styleUrls: ['./course.component.scss'],
    providers: [ByocCourseService],
    standalone: false
})
export class ByocMissionStepCourseComponent implements OnInit, OnDestroy {
    @ViewChild('coursesList', { static: true })
    coursesList!: ByocMissionStepCourseListComponent;

    saving = false;
    creatingCourse = false;

    /**
     * Form Controls
     */
    searchFormControl!: UntypedFormControl;
    originControl!: UntypedFormControl;

    private subscriptions: Subscription = new Subscription();
    private broadcastSubscription?: Subscription;

    constructor(
        private router: Router,
        private changeDetectorRef: ChangeDetectorRef,
        private byocMissionService: ByocMissionService,
        private byocService: ByocService,
        private translateService: TranslateService,
        private messageService: MessageService,
        private broadcastPopupService: BroadcastPopupService,
    ) {}

    ngOnInit() {
        this.searchFormControl = new UntypedFormControl('');
        this.originControl = new UntypedFormControl(origin.all);

        this.subscriptions.add(
            this.byocMissionService.form.valueChanges.subscribe(() => {
                this.byocMissionService.appendSelectedCoursesFullData(this.coursesList.coursesList);
                this.changeDetectorRef.detectChanges();
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    cancelClick(): void {
        this.byocMissionService.close('btn-close');
    }

    backClick(): void {
        this.byocMissionService.step = 'general';
        this.changeDetectorRef.markForCheck();
    }

    saveClick(): void {
        if (this.courses.invalid) {
            return;
        }

        // set as draft
        this.byocMissionService.form.patchValue({ status: 2 });

        // show loader
        this.saving = true;
        this.changeDetectorRef.detectChanges();

        // save as draft and redirect with message
        this.subscriptions.add(
            this.byocService.createMission(this.byocMissionService.form.getRawValue()).subscribe((mission) => {
                this.messageService.setRouteMessage(
                    this.translateService.instant('v3-byoc-popup-create-mission-alert-created', { name: mission.name }),
                    'info',
                );
                if (!this.byocMissionService.isSubmodal) {
                    this.router.navigate(['/manager', 'settings', 'content', 'byoc', 'mission', mission.id]);
                }
                this.byocMissionService.close('btn-close');
            }),
        );
    }

    /**
     * Create Course Click
     */
    createCourseClick() {
        this.broadcastPopupService.send('hideMission');
        this.creatingCourse = true;
        this.broadcastSubscription = this.broadcastPopupService.broadcasts.subscribe((broadcastMessage: BroadcastMessage) => {
            this.closeAddCoursePopup(broadcastMessage.message);
        });
    }

    goToPositionSetting() {
        this.byocMissionService.step = 'position';
        this.changeDetectorRef.markForCheck();
    }

    /**
     * Close - is fired always when popup closes
     */
    private closeAddCoursePopup(course: string): void {
        const courseObject = course !== 'btn-close' && course !== 'close' ? JSON.parse(course) : null;
        this.coursesList.searching = true;
        this.changeDetectorRef.detectChanges();
        this.broadcastSubscription?.unsubscribe();
        this.broadcastPopupService.send('showMission');
        if (courseObject) {
            this.byocMissionService.addCourseControl(courseObject.id, true);
            // this.originControl.setValue(0);

            this.coursesList.newlyCreatedCourses.push(courseObject);
            this.coursesList.inactiveCourses.push(courseObject.id);
            this.byocMissionService.appendSelectedCoursesFullData([courseObject]);
        }
        this.creatingCourse = false;
        this.coursesList.searching = false;
        this.changeDetectorRef.detectChanges();
    }

    /**
     * Course ID Control
     */
    get courses() {
        return this.byocMissionService.coursesFormGroup;
    }

    get selectedCoursesNumber() {
        return this.byocMissionService.selectedCoursesNumber;
    }
}
